/**
 * Cached company info for display purposes.
 * Avoids re-fetching company names when rendering chips.
 */
export type CachedCompany = {
  hgId: string;
  name: string;
  url?: string;
};

export type TargetOrganizationsSlice = {
  /** Company HG IDs for direct targeting */
  hgIds: string[];
  /** Company HG IDs that include corporate relatives */
  hgIdsIncludingCorporateRelatives: string[];
  /** Cache of company details for chip display (hgId -> company info) */
  companiesCache: CachedCompany[];
};

export const defaultTargetOrganizationsSlice: TargetOrganizationsSlice = {
  hgIds: [],
  hgIdsIncludingCorporateRelatives: [],
  companiesCache: [],
};
